import React from 'react';
import { cn } from '../../../utils/classnames';
import { formatCurrency } from '../../../utils/formatters';
import { ArrowDown, ArrowUp, Check } from 'lucide-react';

const BalancingBadge = ({ value, positiveColors, valueType = 'currency' }) => {
  const isPositive = value > 0;

  const isZero = parseInt(value) === 0;

  let statusClass;

  if (isZero) {
    statusClass = 'bg-tealBright text-tealDark';
  } else if (isPositive) {
    if (positiveColors) {
      statusClass = positiveColors;
    } else {
      statusClass = 'bg-yellowExtraLight text-yellowDark';
    }
  } else {
    statusClass = 'bg-redExtraLight text-redDeep';
  }

  const Icon = isZero ? Check : isPositive ? ArrowUp : ArrowDown;

  return (
    <span
      className={cn(
        'inline-grid items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold',
        'tabular-nums whitespace-nowrap',
        statusClass
      )}
      style={{ width: valueType === 'currency' ? '140px' : '75px', gridTemplateColumns: '14px 1fr' }}
    >
      <span className="flex items-center justify-center w-[14px]">
        <Icon size={12} />
      </span>

      <span className="text-left">{valueType === 'currency' ? formatCurrency(Math.abs(value)) : Math.abs(value)}</span>
    </span>
  );
};

export default BalancingBadge;
